import styled from 'styled-components'
import { Link, NavLink } from 'react-router-dom'
import { colors } from '@/styles'
import BackArrow from './back-arrow.svg?react'
import { BreadcrumbProps } from './types'

export const getBackEntry = (items: BreadcrumbProps['items']): string => {
  const index = Math.max(items.length - 2, 0)
  const backEntry = items[index]?.to
  if (typeof backEntry === 'undefined') return ''
  return backEntry
}

export const BreadcrumbList = styled.ol<{ justifyContent?: string }>`
  width: 100%;
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: ${props => props.justifyContent ?? 'flex-start'};
`

export const BackButton = styled(Link)`
  font-weight: 400;
  color: currentColor;
  background: transparent;
  border: none;
  width: fit-content;
  display: flex;
  align-items: center;
  padding: 0;
  cursor: pointer;
`

export const StyledBackArrow = styled(BackArrow).attrs({ 'aria-hidden': true })`
  color: currentColor;
  padding-right: 5px;
  height: 15px;
  width: 18px;
`

export const BreadcrumbAnchor = styled(NavLink)`
  color: ${colors.grey56};
  &[href]:not([aria-current='page']):hover,
  &[href]:not([aria-current='step']):hover {
    text-decoration: underline;
    color: var(--hover-color);
  }

  &[aria-current='page'],
  &[aria-current='step'] {
    color: var(--active-color);
    font-size: var(--active-size);
    font-weight: var(--active-weight);
    pointer-events: none;
  }

  &[aria-current='page'] {
    color: ${colors.black};
  }

  &:not([href]) {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
